const form = () => {
  var elsaPackages = [
    'one_month_credit',
    'three_months_credit',
    'six_months_credit',
    'one_year_credit',
    'one_month_credit_premium',
    'three_months_credit_premium',
    'six_months_credit_premium',
    'one_year_credit_premium',
    'lifetime_membership_premium',
    'one_month_credit_nova_premium',
    'three_months_credit_nova_premium',
    'six_months_credit_nova_premium',
    'one_year_credit_nova_premium',
    'lifetime_membership_nova_premium',
    'two_years_credit',
    'lifetime_membership',
    'oxford_starter',
    'oxford_elementary',
    'oxford_pre_intermediate',
    'oxford_intermediate',
    'oxford_upper_intermediate',
    'oxford_advanced',
    'oxford_all_books',
    'lifetime_membership_combo_elsa_pro_ai_role_play_sa',
    'one_year_credit_bundle_elsa_professional',
    // The Catalog paywalls moved to these SKUs on 2026-09-16. Without them the
    // membership check rejects the chosen package and the lead is never sent.
    'one_year_credit_professional',
    'lifetime_membership_professional'
  ];

  const isMembershipExist = (packages, membership) => {
    var result = false;
    if (Array.isArray(membership) && membership.length > 0) {
      for(let i = 0; i < membership.length; i++) {
        if (packages.includes(membership[i])) {
          result = true;
        } else {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  };

  const buildMembership = (arrayPackages) => {
    var membershipString = '';
    if (arrayPackages.length < 1) return;
    if (arrayPackages.length === 1) {
      membershipString = arrayPackages[0];
    } else {
      arrayPackages.map((item, index) => {
        if (index === arrayPackages.length - 1) {
          membershipString += `1 x ${item}`;
        } else {
          membershipString += `1 x ${item} and `;
        }
      });
    }
    return membershipString;
  };

  const $packageItemSelect = $('.js-select-package');
  $('.list-packages').each(function () {
    const currentMembershipItem = $(this).closest('.section-register').find('input[name="membership"]:checked').attr("id");

    $(this).find('label[for="' + currentMembershipItem + '"]').addClass('is-active');
    $(this).find(`p.${currentMembershipItem}-promotion`).addClass('is-show');
  });

  $packageItemSelect.on('click', function () {
    if (!$(this).hasClass('is-active')) {
      $(this).closest('.list-packages').find($packageItemSelect).removeClass('is-active');
      $(this).stop().addClass('is-active');
      $(this).closest('.list-packages').find('p.discount-code').removeClass('is-show');
      $(this).closest('.list-packages').find('p.' + $(this).attr('for') + '-promotion').addClass('is-show');
    }
  });

  // single checked
  $('.elsa-oxford input[type="checkbox"]').on('change', function() {
    if ($(this).val() === 'oxford_all_books') {
      $('.elsa-oxford input[type="checkbox"]').not(this).prop('checked', false);
    } else {
      $('.elsa-oxford input[value="oxford_all_books"]').not(this).prop('checked', false);
    }
  });

  $('.form-register').each(function () {
    const form = $(this);

    form.on('submit', function (e) {
      e.preventDefault();

      let errorMessage = '';
      let phone = form.find('input[name="phone"]').val();
      const name = form.find('input[name="fullname"]').val();
      const email = form.find('input[name="email"]').val();
      var checkedBoxes = [];
      var hasError = false;

      if (form.find('input[name="membership"]').attr("type") === 'hidden') {
        var membership = form.find('input[name="membership_name"]:checked').val();
        form.find('input[name="membership_name"]:checked').map(function() {
          checkedBoxes.push($(this).val());
        });
        console.log(checkedBoxes);

        var membershipString = buildMembership(checkedBoxes);
        $('input[name="membership"]').val(membershipString);
      } else {
        var membership = form.find('input[name="membership"]:checked').val();
      }

      if (!isPhoneValid(phone)) {
        errorMessage += '<p>* กรุณาใส่เบอร์โทรที่ถูกต้อง</p>'
      }
      if (!name) {
        errorMessage += '<p>* กรุณากรอกชื่อของคุณ</p>'
      }
      if (!validateEmail(email)) {
        errorMessage += '<p>* กรุณาใส่อีเมล์ที่ถูกต้อง</p>'
      }
      if (!membership) {
        errorMessage +='<p>* กรุณาเลือกแพ็คเกจ</p>'
      }
      if (errorMessage) {
        e.preventDefault();
        form.find('.js-form-errors').html(errorMessage).show();
        const offset = form.find('.js-form-errors').offset().top + form.find('.js-form-errors').innerHeight() - $(window).height() + 3;
        $('html, body').animate({
          scrollTop: offset
        }, 800)
        return;
      }
      form.find('.js-form-errors').html('').hide();

      const packageName = {
        three_months_credit: {
          amount: '629',
          label: 'THREE MONTHS CREDIT'
        },
        six_months_credit: {
          amount: '925',
          label: 'SIX MONTHS CREDIT'
        },
        one_year_credit: {
          amount: '1699',
          label: 'ONE YEAR CREDIT'
        },
        three_months_credit_premium: {
          amount: '3078',
          label: 'THREE MONTHS CREDIT PREMIUM'
        },
        one_month_credit_premium: {
          amount: '1578',
          label: 'ONE MONTH CREDIT PREMIUM'
        },
        one_year_credit_premium: {
          amount: '1699',
          label: 'ONE YEAR CREDIT PREMIUM'
        },
        lifetime_membership_premium: {
          amount: '3199',
          label: 'LIFETIME MEMBERSHIP PREMIUM'
        },
        lifetime_membership: {
          amount: '3199',
          label: 'LIFETIME MEMBERSHIP'
        },
        oxford_starter: {
          amount: '179',
          label: 'OXFORD STARTER'
        },
        oxford_elementary: {
          amount: '179',
          label: 'OXFORD ELEMENTARY'
        },
        oxford_pre_intermediate: {
          amount: '179',
          label: 'OXFORD PRE INTERMEDIATE'
        },
        oxford_intermediate: {
          amount: '179',
          label: 'OXFORD INTERMEDIATE'
        },
        oxford_upper_intermediate: {
          amount: '179',
          label: 'OXFORD UPPER INTERMEDIATE'
        },
        oxford_advanced: {
          amount: '179',
          label: 'OXFORD ADVANCED'
        },
        oxford_all_books: {
          amount: '729',
          label: 'OXFORD ALL BOOKS'
        }
      };

      window.dataLayer.push({
        event: 'Submit_form_successful', forminput: {
          full_name: name,
          phone: phone,
          email: email,
          package_name: packageName[membership]?.label,
          package: membership,
          amount: packageName[membership]?.amount
        }
      });

      if (!hasError) {
        form[0].submit();
      }
    });
  });

  $('input[name="search"]').val(location.search);

  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function isPhoneValid(phone) {
    var flag = false;
    var re = /^(\+66|0)\d{9}$/;
    if (phone !== "") {
      if (re.test(phone)) {
        flag = true;
      }
    }
    return flag;
  }
};

export default form;
